import { useEffect, useState } from "react";
import { Box, Grid, GridItem, Link, Text, useColorMode } from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";
import giveawayImg from "../../assets/image/giveaway.png";

const contestEndDate = new Date("2026-05-01T00:00:00");

const getTimeLeft = () => {
  const diff = Math.max(0, contestEndDate.getTime() - Date.now());
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const MainPageFreeAmmo = () => {
  const { colorMode } = useColorMode();
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      mt={{ base: 6, md: 8 }}
      borderRadius="xl"
      border="1px solid"
      borderColor={getCurrentColor(colorMode, "grayC.500", "transparent")}
      bg={getCurrentColor(colorMode, "blueC.800", "grayC.1700")}
      p={{ base: 6, sm: 8, md: 10 }}
      textAlign="center"
    >
      {/* Title */}
      <Text
        fontSize={{ base: "2xl", sm: "3xl", md: "5xl" }}
        fontWeight="extrabold"
        textTransform="uppercase"
        color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
        mb={{ base: 4, md: 6 }}
      >
        PSA Gift Card Giveaway!
      </Text>

      {/* Giveaway image */}
      <Link href="/giveaway" display="block" mb={{ base: 4, md: 6 }}>
        <Box
          as="img"
          src={giveawayImg}
          alt="PSA $500 Gift Card Giveaway"
          borderRadius="lg"
          mx="auto"
          w="100%"
          maxW={{ base: "100%", md: "2xl" }}
          cursor="pointer"
          transition="opacity 0.2s"
          _hover={{ opacity: 0.9 }}
        />
      </Link>

      {/* Countdown label */}
      <Text
        fontSize="xs"
        fontWeight="semibold"
        textTransform="uppercase"
        letterSpacing="widest"
        color={getCurrentColor(colorMode, "grayC.100", "grayC.1600")}
        mb={3}
      >
        Ends In:
      </Text>

      {/* Countdown boxes */}
      <Grid
        templateColumns="repeat(4, 1fr)"
        gap={{ base: 2, sm: 3 }}
        maxW={{ base: "280px", sm: "360px", md: "420px" }}
        mx="auto"
        mb={{ base: 5, md: 6 }}
      >
        {Object.entries(timeLeft).map(([label, val]) => (
          <GridItem
            key={label}
            bg={getCurrentColor(colorMode, "grayC.500", "whiteAlpha.100")}
            borderRadius="lg"
            py={{ base: 2, sm: 3 }}
            px={2}
          >
            <Text
              fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
              fontWeight="extrabold"
              color="blue.400"
              lineHeight={1}
            >
              {val}
            </Text>
            <Text
              fontSize={{ base: "9px", sm: "xs" }}
              textTransform="uppercase"
              color={getCurrentColor(colorMode, "grayC.100", "grayC.1600")}
              mt={1}
            >
              {label}
            </Text>
          </GridItem>
        ))}
      </Grid>

      {/* Enter Now button */}
      <Link
        href="/giveaway"
        display="inline-block"
        bg="blue.400"
        color="white"
        fontWeight="extrabold"
        fontSize={{ base: "lg", sm: "xl" }}
        px={{ base: 12, sm: 24 }}
        py={{ base: 4, sm: 5 }}
        borderRadius="lg"
        _hover={{ bg: "blue.500", textDecoration: "none" }}
        transition="background 0.2s"
        mt={2}
        w={{ base: "full", sm: "auto" }}
      >
        Enter Now
      </Link>
    </Box>
  );
};

export default MainPageFreeAmmo;
